import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from '../index.scss';
import searchBoxCss from '../styles/search.scss';
import DropDownList from '../../dropdown-list/index';
import { FULL_WIDTH } from '../../dropdown-list/constant';
import messages from '../messages';
import productEnum from '../../../helpers/product-enum';
import classEnum from '../../../containers/class-roll/constants';
import TextInput from '../../text-input';

const AssignCourseFilter = (props) => {
    const { intl,
        yearGroups,
        countries,
        handleOnYearGroupChange,
        handleOnCountryChange,
        handleOnSearchCourse,
        searchQuery,
        disableSearch,
        disableYearGroup,
        selectedYearGroupId,
        isLoadingCountryYearGroups,
        selectedProduct
    } = props;

    const countriesList = countries.slice(0);
    const isMathletics = selectedProduct.id === productEnum.MATHLETICS.id;

    if (isMathletics) {
        countriesList.unshift({
            name: intl.formatMessage(messages.schoolCourses),
            code: classEnum.SCHOOL_COURSES
        });
    }

    const clearText = true;
    return (<div>
        <div className={css.defaultCourse}>
            <div className={css.heading}>{intl.formatMessage(messages.startCourse)}:</div>
            <div className={css.subHeading}>{intl.formatMessage(messages[isMathletics ? 'coursesActivityMastery' : 'courses'])}</div>
            <DropDownList
                name="countries"
                onChange={handleOnCountryChange}
                optionKey="code"
                options={countriesList}
                optionText="name"
                placeholder={intl.formatMessage(messages.defaultOptionCountry)}
                variant={FULL_WIDTH}
            />
            <DropDownList
                disabled={disableYearGroup}
                isLoading={isLoadingCountryYearGroups}
                name="yearGroups"
                onChange={handleOnYearGroupChange}
                optionKey="yearGroupEnum"
                options={yearGroups}
                optionText="longName"
                placeholder={intl.formatMessage(messages.selectGrade)}
                value={selectedYearGroupId}
                variant={FULL_WIDTH}
            />
            <div className={css.searchContainer}>
                <TextInput
                    clearText={clearText}
                    css={searchBoxCss}
                    disabled={disableSearch}
                    handleOnChange={handleOnSearchCourse}
                    placeholder={intl.formatMessage(messages.searchCourse)}
                    type="text"
                    value={searchQuery} />
            </div>
        </div>
    </div>);
};

AssignCourseFilter.propTypes = {
    intl: intlShape.isRequired,
    yearGroups: PropTypes.array,
    countries: PropTypes.array,
    handleOnYearGroupChange: PropTypes.func,
    handleOnCountryChange: PropTypes.func,
    handleOnSearchCourse: PropTypes.func,
    searchQuery: PropTypes.string,
    disableSearch: PropTypes.bool,
    disableYearGroup: PropTypes.bool,
    isLoadingCountryYearGroups: PropTypes.bool,
    selectedYearGroupId: PropTypes.string,
    selectedProduct: PropTypes.object
};


export default injectIntl(styleable(css)(AssignCourseFilter));



// WEBPACK FOOTER //
// ./app/components/assign-course-legacy/pages/assign-course-filter.js